const CustomerStripe = ({ customer }) => {

    if (!customer?.stripe) {
        return (
            <p>
                <pre>{'{}'}</pre>
            </p>
        );
    }

    return (
        <p>
            <pre>{JSON.stringify(customer.stripe, undefined, 4)}</pre>
        </p>
    );
};

export { CustomerStripe };
